/**
 * YouTube Utility Functions
 * Helper functions for working with YouTube URLs and video IDs
 */

/**
 * Extracts video ID from various YouTube URL formats
 * @param {string} url - YouTube URL or video ID
 * @returns {string|null} - Video ID or null if invalid
 */
export const extractVideoId = (url) => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  // If it's already just a video ID (11 characters, alphanumeric)
  if (/^[a-zA-Z0-9_-]{11}$/.test(url.trim())) {
    return url.trim();
  }

  // YouTube URL patterns
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/.*[?&]v=([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

/**
 * Validates if input is a valid YouTube URL or video ID
 * @param {string} input - YouTube URL or video ID
 * @returns {boolean} - True if valid
 */
export const isValidYouTubeInput = (input) => {
  if (!input || typeof input !== 'string') {
    return false;
  }

  const trimmed = input.trim();
  
  // Check if it's a valid video ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
    return true;
  }

  // Check if it's a valid YouTube URL
  const urlPatterns = [
    /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\/.+/,
  ];

  return urlPatterns.some(pattern => pattern.test(trimmed));
};



